import { render, staticRenderFns } from "./BlockPage.vue?vue&type=template&id=6f92cff3&"
import script from "./BlockPage.ts?vue&type=script&lang=ts&"
export * from "./BlockPage.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports